import { IconPlaylistAddCheck } from "@/assets/icons";
import { DetailFooterShell } from "@/components/commons/DetailFooterShell";
import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

// Footer for the input step (Hình 1). 確認 is the form submit → advances to the review step.
export const EmailChangeFormFooter: FC = () => {
  const navigate = useNavigate();

  return (
    <DetailFooterShell>
      <Button variant="ghost" size="sm" type="button" onClick={() => navigate(AppRoutes.userSettingDetail)}>
        戻る
      </Button>
      <Button variant="primary" size="sm" type="submit">
        <Stack direction="row" alignItems="center" gap="8px">
          <IconPlaylistAddCheck fontSize={20} />
          確認
        </Stack>
      </Button>
    </DetailFooterShell>
  );
};
